/* TODO: Refactor this file to generate dates by traversing filtered implementation object.keys
 * (eg. don't generate completedByUserUuid & status).
 * We can probably leverage C:\Users\jwcom\Desktop\Kana\web\src\route\shared\projects\project\overview\components\StandardSpecificSection\components\RenderComponent.tsx
 * to do this, we will need to remove the expression interpreter / schema related bits from it
 * Will create a shared compenent for all dates sections for this
 */
import "./ImplementationSection.css";

import { ProjectDatesConstants } from "../../../../constants";
import { ProjectPhaseStatus } from "../../../../models";
import { Column, DatePicker, KanaTooltip, Row, TextInput } from "../../../../widget";
import { EditDatesPanelBanner } from "../EditDatesPanelBanner";
import { DateSectionProps } from "../models";

const START_LABEL = "Phase start date";
const END_LABEL = "Phase end date";
export const ImplementationSection = ({
  dates,
  handleUpdateProjectDates,
  hasDateError,
  schema,
}: DateSectionProps): JSX.Element => {
  return (
    <>
      <Row spacingV="m">
        <Column span={12}>
          <p className="body01">Implementation</p>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span={12}>
          <p className="body1">
            Enter key dates to help structure your workflow and align with your broader roadmap. These can be either
            confirmed or estimated, and can be updated as the project develops.
          </p>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span="4_half">
          <DatePicker
            label={START_LABEL}
            value={dates.implementation?.start}
            onChange={(date) => handleUpdateProjectDates(date, "implementation.start")}
            hasError={hasDateError("implementation.start")}
            tooltip={
              <KanaTooltip
                tooltipHeader=""
                tooltipText={ProjectDatesConstants.IMPLEMENTATION_START_TOOLTIP_TEXT}
                hasError={hasDateError("implementation.start")}
              />
            }
          />
        </Column>
        <Column offset="1_half" span="4_half">
          <DatePicker
            label={END_LABEL}
            value={dates.implementation?.end}
            onChange={(date) => {
              handleUpdateProjectDates(date, "implementation.end");
              handleUpdateProjectDates(
                date !== undefined ? new Date(new Date(date).setDate(date.getDate() + 1)) : undefined,
                "ongoingMonitoring.overallStart"
              );
            }}
            hasError={hasDateError("implementation.end")}
            tooltip={
              <KanaTooltip
                tooltipHeader=""
                tooltipText={ProjectDatesConstants.IMPLEMENTATION_END_TOOLTIP_TEXT}
                hasError={hasDateError("implementation.end")}
              />
            }
          />
        </Column>
      </Row>
      <Row spacingV="l">
        {schema?.implementation.properties.implementationDate !== undefined && (
          <Column span="4_half">
            <div className="ImplementationSectionOptionalDatePickerContainer">
              <DatePicker
                label="Project implementation date"
                value={dates.implementation?.implementationDate}
                onChange={(date) => handleUpdateProjectDates(date, "implementation.implementationDate")}
                hasError={hasDateError("implementation.implementationDate")}
                tooltip={
                  <KanaTooltip
                    tooltipHeader=""
                    tooltipText={ProjectDatesConstants.IMPLEMENTATION_IMPLEMENTATION_DATE_TOOLTIP_TEXT}
                    hasError={hasDateError("implementation.implementationDate")}
                  />
                }
              />
            </div>
          </Column>
        )}
        {schema?.implementation.properties.certificationDate !== undefined && (
          <Column span="4_half">
            <div className="ImplementationSectionOptionalDatePickerContainer">
              <DatePicker
                label="Certification date"
                value={dates.implementation?.certificationDate}
                onChange={(date) => handleUpdateProjectDates(date, "implementation.certificationDate")}
                hasError={hasDateError("implementation.certificationDate")}
                tooltip={
                  <KanaTooltip
                    tooltipHeader=""
                    tooltipText={ProjectDatesConstants.IMPLEMENTATION_CERTIFICATION_DATE_TOOLTIP_TEXT}
                    hasError={hasDateError("implementation.certificationDate")}
                  />
                }
              />
            </div>
          </Column>
        )}
        {schema?.implementation.properties.startDate !== undefined && (
          <Column
            offset={schema?.implementation.properties.implementationDate !== undefined ? "1_half" : undefined}
            span="4_half"
          >
            <div className="ImplementationSectionOptionalDatePickerContainer">
              <DatePicker
                label="Project start date"
                value={dates.implementation?.startDate}
                onChange={(date) => handleUpdateProjectDates(date, "implementation.startDate")}
                hasError={hasDateError("implementation.startDate")}
                tooltip={
                  <KanaTooltip
                    tooltipHeader=""
                    tooltipText={ProjectDatesConstants.IMPLEMENTATION_START_DATE_TOOLTIP_TEXT}
                    hasError={hasDateError("implementation.startDate")}
                  />
                }
              />
            </div>
          </Column>
        )}
        {schema?.implementation.properties.validationDate !== undefined && (
          <Column
            span="4_half"
            offset={
              schema?.implementation.properties.startDate === undefined ||
              schema?.implementation.properties.implementationDate === undefined
                ? "1_half"
                : undefined
            }
          >
            <div className="ImplementationSectionOptionalDatePickerContainer">
              <DatePicker
                label="Validation date"
                value={dates.implementation?.validationDate}
                onChange={(date) => handleUpdateProjectDates(date, "implementation.validationDate")}
                hasError={hasDateError("implementation.validationDate")}
                tooltip={
                  <KanaTooltip
                    tooltipHeader=""
                    tooltipText={ProjectDatesConstants.IMPLEMENTATION_FIRST_ASSESSMENT_DATE_TOOLTIP_TEXT}
                    hasError={hasDateError("implementation.validationDate")}
                  />
                }
              />
            </div>
          </Column>
        )}
        {schema?.implementation.properties.restorationValidationDate !== undefined && (
          <Column span="4_half">
            <div className="ImplementationSectionOptionalDatePickerContainer">
              <DatePicker
                label="Restoration validation date"
                value={dates.implementation?.restorationValidationDate}
                onChange={(date) => handleUpdateProjectDates(date, "implementation.restorationValidationDate")}
                hasError={hasDateError("implementation.restorationValidationDate")}
                tooltip={
                  <KanaTooltip
                    tooltipHeader=""
                    tooltipText={ProjectDatesConstants.IMPLEMENTATION_RESTORATION_VALIDATION_DATE_TOOLTIP_TEXT}
                    hasError={hasDateError("implementation.restorationValidationDate")}
                  />
                }
              />
            </div>
          </Column>
        )}
        <Column
          offset={
            schema?.implementation.properties.startDate !== undefined &&
            (schema.implementation.properties.implementationDate !== undefined ||
              schema.implementation.properties.restorationValidationDate !== undefined)
              ? "1_half"
              : undefined
          }
          span="4_half"
        >
          <TextInput
            label="Project duration"
            name="Project duration"
            value={dates.duration?.duration?.toString()}
            onChange={(date) => handleUpdateProjectDates(Number(date), "duration.duration")}
            tooltip={
              <KanaTooltip tooltipHeader="" tooltipText={ProjectDatesConstants.IMPLEMENTATION_DURATION_TOOLTIP_TEXT} />
            }
          />
        </Column>
      </Row>
      <EditDatesPanelBanner
        phaseStatus={dates.implementation.status as ProjectPhaseStatus}
        phaseEndDate={dates.implementation.end}
      />
    </>
  );
};
